// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"f25ff4ce","155":"b1f914a2","166":"40d6a286","229":"2a77134d","329":"16f930af","377":"40f955bf","445":"e5ccd81e","463":"73697e93","517":"23b4064a","635":"2a5da89c","681":"bfa33708","744":"f903fe03","844":"ed3c93ec","927":"0e308839","961":"142bc0a9"}[chunkId] + ".chunk.js";
};